import { type Translationtype } from "utils";
import { Tooltip } from "../components/tooltip";

interface IFormFileInputProps {
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  tooltip?: string;
  name: string;
  title?: string;
  accept?: string;
  multiple?: boolean;
  noTitle?: boolean;
  t: Translationtype;
}

export function FormFileInput({
  register,
  errors,
  className,
  disabled,
  tooltip,
  name,
  title = "",
  accept,
  multiple,
  noTitle = false,
  t,
}: IFormFileInputProps) {
  return (
    <div className={`${className || ""} w-full`}>
      {!noTitle ? (
        <label htmlFor={name} className="w-full block mb-3 text-textColor">
          {title}
          {tooltip ? <Tooltip text={tooltip} /> : null}
        </label>
      ) : null}
      <input
        id={name}
        type="file"
        accept={accept}
        multiple={multiple ?? false}
        className="file-input w-full"
        disabled={disabled || false}
        {...register(name)}
      />
      {errors[`${name}`]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[`${name}`]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
